import createCRUDObservable from 'redux-observable-crud'
import { combineEpics } from 'redux-observable'
import { Observable } from 'rxjs'
import TotalAttendanceActions, { TotalAttendanceRedux, TotalAttendanceTypes } from '../Redux/TotalAttendanceRedux'
import { notificationFail } from '../Redux/NotificationActions'

const totalAttendanceCrudObservable = createCRUDObservable({
  mainRedux: TotalAttendanceRedux,
  reduxPath: 'totalAttendance',
})

const totalAttendanceExcelEpic = (action$, store, { Api }) =>
  action$.ofType(TotalAttendanceTypes.TotalAttendanceExcelRequest)
    .mergeMap(() => (
      Observable
        .fromPromise(Api.totalAttendance.getTotalAttendanceExcel()
          .then(response => response)
          .catch(error => error))
        .flatMap((response) => {
          const { status } = response
          if (!(status >= 200 && status < 300)) {
            return [notificationFail('Falló la descarga')]
          }
          const file = response.headers['content-disposition']
          const index = file.indexOf('=')
          const fileName = file.substring(index + 1, file.length)
          const url = window.URL.createObjectURL(new Blob([response.data]))
          const link = document.createElement('a')
          link.href = url
          link.setAttribute('download', fileName)
          document.body.appendChild(link)
          link.click()
          return [
            TotalAttendanceActions.TotalAttendanceExcelSuccess(),
          ]
        })
    ))

export const totalAttendanceObservers = Object.assign({}, totalAttendanceCrudObservable.observers, {})

export const totalAttendanceEpic = combineEpics(
  totalAttendanceCrudObservable.epic,
  totalAttendanceExcelEpic,
)



// WEBPACK FOOTER //
// ./src/Data/Observables/TotalAttendanceObservable.js